import { ListingApiService } from "@/lib/depict-client/services/ListingApiService"
import { ClientFetchService } from "@/lib/http/ClientFetchService"
import logger from "@/lib/logger/logger-init"
import { depictClientConfig } from "./interfaces/IDepictClientConfig"

const clientFetchService = new ClientFetchService(depictClientConfig, logger)

const listingApiService = new ListingApiService(clientFetchService)

const depictListingClient = { listing: listingApiService }

export default depictListingClient
